import {POLICY_TYPE, RESOURCE_TYPE} from './Policy.types'

export interface AnalyticsDetailAPIResponseBody {
  message: string
  response: AnalyticsDetailAPIResponse
}

export interface AnalyticsDetailAPIResponse {
  Items?: AnalyticsDetailListItem[]
  LastEvaluatedKey?: LastEvaluatedKey
  fileUrl?: string
}

export interface LastEvaluatedKey {
  activeStatusNumber: string
  tenantId: string
  tenantId_agentUUID_userUUID: string
}

export interface AnalyticsDetailListItem {
  clientCity: string
  catname: string
  tenantId: string
  user: string
  url: string
  oidc_user_name: string
  oidcUser: string
  aws_region: string
  datetime: string
  vpk: string
  catsk: string
  searchpk: string
  blockDetail: string
  clientLoc: string
  domain: string
  version: string
  catpk: string
  timestamp: string
  fallbackState: boolean
  clientCountry: string
  policyType: POLICY_TYPE
  policyName: string
  expires_at: number
  vsk: string
  destinationIP: string
  verdict: number
  category: string
  processName: string
  cacheMiss: boolean
  agentId: string
  searchsk: string
  app: string
  fileName?: string
  fileHash?: string
}

// Redux state interfaces
export interface AnalyticsDetailResponse {
  Items: AnalyticsDetailItem[]
  LastEvaluatedKey: LastEvaluatedKey
}

export interface AnalyticsDetailItem {
  domain: string
  urlPath: string
  location: string
  destinationIP: string
  category: string
  user: string
  type: string
  verdict: string
  time: string
  fallbackMode: string
  cacheMiss: string
  policyName?: string
  processName?: string
  fileName?: string
  fileHash?: string
  userName?: string
  oidcUser?: string
  blockDetail?: string
}

export interface AnalyticsDetailState {
  policyType: POLICY_TYPE[]
  resourceType: RESOURCE_TYPE[]
  filterDetails: GetAnalyticsDetailFilterDetails
  sortAscending: boolean
}

export interface AnalyticsDetailFilters {
  policyTypes: POLICY_TYPE[]
}

// Redux actions interfaces
export interface GetAnalyticsDetailRequestPayload {
  limit?: number
  sortAscending?: boolean
  filter?: GetAnalyticsDetailFilter
  LastEvaluatedKey?: LastEvaluatedKey
  dateTime?: string
}

export interface GetAnalyticsDetailRequestParams {
  download: boolean
}

export interface GetAnalyticsDetailFilter {
  policyType?: POLICY_TYPE[]
  resourceType?: RESOURCE_TYPE[]
  filterDetails?: GetAnalyticsDetailFilterDetails
}

export interface GetAnalyticsDetailFilterDetails {
  city?: string
  country?: string
  groupEmail?: string
  userEmail?: string
  category?: string
}

// Table column render function parameter interfaces
export interface DetailTableRenderDataParams {
  classes?: string
  value: string
  dispatchSetAnalyticsDetailFilters: (filters: GetAnalyticsDetailFilter) => void
}

export interface DetailTableColumn {
  name: string
  dataKey: string
  widthPercentage: number
  classes?: string
  transform?: (value: string) => string
  renderData?: (params: DetailTableRenderDataParams) => React.ReactNode
  renderColumn?: (params: {name: string}) => React.ReactNode
}

// Table column interfaces
export interface DetailTableRenderDataParams {
  classes?: string
  value: string
  dispatchSetAnalyticsDetailFilters: (filters: GetAnalyticsDetailFilter) => void
}

export interface DetailTableRenderColumnParams {
  name: string
}

// Main table column interface - lean structure
export interface DetailTableColumn {
  name: string
  dataKey: string
  widthPercentage: number
  classes?: string
  transform?: (value: string) => string
  renderData?: (params: DetailTableRenderDataParams) => React.ReactNode
  renderColumn?: (params: DetailTableRenderColumnParams) => React.ReactNode
}

// Enum for recategorization status
export enum RecategorizationStatus {
  PENDING_CATEGORISATION = 'PENDING_CATEGORISATION',
  RECATEGORISED = 'RECATEGORISED',
  NOT_RECATEGORISED = 'NOT_RECATEGORISED',
}

/**
 * Interface representing the recategorization status response for a URL
 */
export interface RecategorizationStatusResponse {
  domain: string
  status: RecategorizationStatus
  lastUpdated: string
  categories?: string[]
  reason?: string
}

export enum CategoryValueType {
  UNKNOWN = 'Unknown',
}

// Table column render function parameter interfaces
export interface DetailTableRenderDataParams {
  classes?: string
  value: string
  dispatchSetAnalyticsDetailFilters: (filters: GetAnalyticsDetailFilter) => void
}

export interface DetailTableRenderColumnParams {
  name: string
}

// Main table column interface
export interface DetailTableColumn {
  name: string
  dataKey: string
  widthPercentage: number
  classes?: string
  transform?: (value: string) => string
  renderData?: (params: DetailTableRenderDataParams) => React.ReactNode
  renderColumn?: (params: DetailTableRenderColumnParams) => React.ReactNode
}
